<div class="facial-recognition-image-uploader">
  <fgb-facial-recognition-uploader-header
    facialRecognitionHeading="{{ 'facial.recognition.take.photo.heading' | translate }}"
    facialRecognitionSubheading="{{ 'facial.recognition.take.photo.subheading' | translate }}"
    [stepCounter]="stepCounter"
    [showCloseButton]="true"
    (previousStepChange)="previousStepChange.emit()"
  ></fgb-facial-recognition-uploader-header>
  <div class="container facial-recognition-details-div mt-3">
    <div class="border facial-recognition-photo-div mb-2">
      <webcam
        *ngIf="stepCounter == 1"
        class="facial-recognition-photo"
        [trigger]="triggerObservable"
        (imageCapture)="handleImage($event)"
        [imageQuality]="1"
        [videoOptions]="cameraOptions"
        [allowCameraSwitch]="false"
        [mirrorImage]="'never'"
        (initError)="handleInitError($event)"
      ></webcam>
    </div>
    <div class="facial-recognition-area">
      <div class="facial-recognition-square-box">
        <div class="oval-outline"></div>
      </div>
    </div>
    <ul
      class="facial-recognition-info font-size-14 px-2"
      [innerHtml]="'facial.recognition.info' | translate | markdownTranslate"
    ></ul>
  </div>

  <div class="container facial-recognition-buttons-div">
    <fgb-facial-recognition-uploader-button
      [facialRecognitionButtonType]="3"
      (capturePhoto)="capturePhoto()"
    ></fgb-facial-recognition-uploader-button>
  </div>
</div>
